module.exports = function getResource(label, vars = []) {
    const resources = {
        allPhotos: 'Toutes les photos',
        myPhotos: 'Mes photos',
        addAPhoto: 'Ajouter une photo'
    };
    return resources[label];
};
